import { Container } from "@mantine/core";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { useIsMobile } from "@/hooks";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes")({
  component: RouteComponent
});

function RouteComponent() {
  const isMobile = useIsMobile();

  return (
    <Container size="2xl" p={0}>
      <Outlet />
    </Container>
  );
}
